import React from "react";
import PropTypes from 'prop-types';
import {Checkbox, Divider, ListItem, ListItemText} from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {Draggable} from "react-beautiful-dnd";
import {multiLanguageValue} from "../../../../../../JsonScreen/Utils/lib";
import {useSelector} from "react-redux";

const useStyles = makeStyles(() => ({
    listItemDense: props =>  ({
        paddingLeft: props.level,
        paddingTop: 0,
        paddingBottom: 0
    })
}));

const RenderDraggableItem = ({column, index, checkBoxChange, level}) => {
    const {userLanguage} = useSelector(state => state.app);
    const multiLanguageLabel = multiLanguageValue(column.label, userLanguage)
    const classes = useStyles({ level: level * 10});
    return (
        <Draggable
            draggableId={column.name}
            index={Number(index)}
            isDragDisabled={column.dropped}
        >
            {(provided, snapshot) => (
                <>
                    <ListItem
                        classes={{dense: classes.listItemDense}}
                        disableGutters
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}>
                        <Checkbox checked={column.dropped || false}
                                  size={"small"}
                                  value={column.dropped || false}
                                  onChange={(event) => checkBoxChange(event, column)}
                                  style={{padding: 0, marginRight: 5}}
                                  color={"primary"}/>
                        <ListItemText primary={multiLanguageLabel}/>
                    </ListItem>
                    <Divider/>
                    {snapshot.isDragging && (
                        <>
                            <ListItem selected={true} className={'react-beatiful-dnd-copy'}>
                                <Checkbox checked={column.dropped || false}
                                          size={"small"}
                                          style={{padding: 0, marginRight: 5}}
                                          color={"primary"}/>
                                <ListItemText primary={multiLanguageLabel}/>
                            </ListItem>
                            <Divider/>
                        </>
                    )}
                </>
            )}
        </Draggable>
    )
};
export default RenderDraggableItem

RenderDraggableItem.propTypes = {
    column: PropTypes.object,
    index: PropTypes.number,
    checkBoxChange: PropTypes.func,
    level: PropTypes.number
};